'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colors = require('./colors.json');

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _colors2.default; // this file is technically unecesscary, we could update all paths to point to the json


// WEBPACK FOOTER //
// ./node_modules/@rategravity/frontend/theme/colors.js